/* eslint-disable no-underscore-dangle */
export const GEOSERVER_API_REST = (window as any)._env_.REACT_APP_GEOSERVER_API_REST || 'https://metconsole-gis.secmotic.com/geoserver/rest';
export const GEOSERVER_API = (window as any)._env_.REACT_APP_GEOSERVER_API || 'https://metconsole-gis.secmotic.com/geoserver';

export const METCONSOLE_API = (window as any)._env_.REACT_APP_METCONSOLE_API || 'https://scimat-dtn.secmotic.com/api/v1';

export const KEYCLOAK_API = (window as any)._env_.REACT_APP_KEYCLOAK_API || 'https://keycloak-dtn.secmotic.com/realms/master';

export const ADSB_API = (window as any)._env_.REACT_APP_ADSB_API || 'http://localhost:4002';
export const SOCKET_SERVER_URL = (window as any)._env_.REACT_APP_SOCKET_SERVER_URL || 'http://localhost:4000';

export const DTN_API = (window as any)._env_.REACT_APP_DTN_API || 'https://map.api.dtn.com/v2';
export const DTN_AUTH_API = (window as any)._env_.REACT_APP_DTN_AUTH_API || 'https://api.auth.dtn.com/v1';
export const BASE_LAYER_PROVIDER: 'geoserver' | 'osm' = (window as any)._env_.REACT_APP_BASE_LAYER_PROVIDER || 'geoserver';

export const DTN_TILE_PROVIDER_ENABLED: boolean = (window as any)._env_.REACT_APP_DTN_TILE_PROVIDER_ENABLED === 'true';

export const KML_ARENA_PATH: string = (window as any)._env_.REACT_APP_KML_ARENA_PATH || '/kml/ARENA.kml';
export const KML_CTR_PATH: string = (window as any)._env_.REACT_APP_KML_CTR_PATH || '/kml/CTR.kml';
export const KML_FIR_PATH: string = (window as any)._env_.REACT_APP_KML_FIR_PATH || '/kml/FIR.kml';
